import styled from "styled-components";

const Tag = styled.div`
  height: var(--height);
  border-radius: calc(var(--height) / 2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Tag;
